export default __webpack_public_path__ + "static/7-e87c3def72cb0216ac4644049ecc7d6d.png";